import { TemplateBinding } from "@angular/compiler";
import { Injectable } from "@angular/core";
import { FormArray, ValidationErrors } from "@angular/forms";

@Injectable()
export class FormValidationService {
    private touched: boolean = false;

  addValidationClass(fromControl, formField) {
    if (fromControl.controls[formField].invalid && (fromControl.controls[formField].touched || fromControl.controls[formField].dirty)) {
      return { 'error-message': true }
    }
    else {
      return { 'error-message': false }
    }
  }
  addValidationClassDirty(fromControl, formField) {
   
    if (fromControl.controls[formField].invalid && (fromControl.controls[formField].touched && fromControl.controls[formField].dirty)) {
      return { 'error-message': true }
    }
    else {
      return { 'error-message': false }
    }
  }

  addSelectValidationClass(fromControl,formArray,OnSave = false){
        let temp = fromControl.get(formArray) as FormArray;
        if (!temp.valid && (temp.touched || OnSave)) {
            return { 'error-message': true }
        }
        else {
            return { 'error-message': false }
        }
    }

    addCheckboxValidationClass(fromControl, formArray, OnSave = false) {
        let fromControlArray = fromControl.get(formArray) as FormArray;
       
        if (fromControlArray.length == 0 &&  OnSave) {
            return { 'error-message': true }
        }
        else {
            return { 'error-message': false }
        }
    }

    getFormValidationErrors(fromControl) {
        Object.keys(fromControl.controls).forEach(key => {
            const controlErrors: ValidationErrors = fromControl.get(key).errors;
            if (controlErrors != null) {
                Object.keys(controlErrors).forEach(keyError => {
                    fromControl.controls[key].markAsTouched()
                });
            }
        });
    }
    markAsTouched(formControl) {

        for (let i = 0; i < formControl.length; i++) {
            var fromArray = <FormArray>(formControl[i]);
            let fromArrayKeys = Object.keys(fromArray.controls);
            fromArrayKeys.forEach(element => {
                fromArray.controls[element].markAsTouched();
            });
        }
    }
  }




// WEBPACK FOOTER //
// ./src/app/domain/authorization/FormValidation.service.ts